import { z } from 'zod'

import { PASSWORD_MESSAGES, passwordSchema } from '../password'
import { emailSchema } from './common'
import { UserDtoSchema } from './user'

/** No login a senha só precisa existir: a regra de força vale para criação e troca. */
const loginPasswordSchema = z
  .string({ error: PASSWORD_MESSAGES.required })
  .min(1, { error: PASSWORD_MESSAGES.required })

export const LoginRequestSchema = z.object({
  email: emailSchema,
  password: loginPasswordSchema,
  rememberDevice: z.boolean().optional(),
})
export type LoginRequest = z.infer<typeof LoginRequestSchema>

export const LoginResponseSchema = z.object({
  accessToken: z.string().min(1),
  user: UserDtoSchema,
})
export type LoginResponse = z.infer<typeof LoginResponseSchema>

export const ForgotPasswordRequestSchema = z.object({
  email: emailSchema,
})
export type ForgotPasswordRequest = z.infer<typeof ForgotPasswordRequestSchema>

const INVALID_RESET_LINK = 'Link de redefinição inválido.'

export const ResetPasswordRequestSchema = z.object({
  token: z.string({ error: INVALID_RESET_LINK }).min(1, { error: INVALID_RESET_LINK }),
  password: passwordSchema,
})
export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequestSchema>

export const ChangePasswordRequestSchema = z
  .object({
    currentPassword: loginPasswordSchema,
    newPassword: passwordSchema,
  })
  .refine((value) => value.currentPassword !== value.newPassword, {
    error: 'A nova senha precisa ser diferente da atual.',
    path: ['newPassword'],
  })
export type ChangePasswordRequest = z.infer<typeof ChangePasswordRequestSchema>
